<div class="container mt-3">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="text-center">
            <img alt="..." src="../../../assets/images/logo-blue@3x.png" style="width: 300px;">
          </div>
          <ngb-progressbar [value]="currentProgress" class="mt-5" type="primary"/>
          <h2 class="mt-4 text-center h3 text-gray-800">Chargement de l'application en cours...</h2>
        </div>
      </div>
    </div>
  </div>
</div>
